const workData = [
    {
        title: "Interaction Design",
        items: [
            {
                url: {
                    ENG: "https://www.hnine.com/en/project/interactive-blind-controller-renewal.html",
                    KOR: "https://www.hnine.com/project/interactive-blind-controller-renewal.html",
                },
                imgURL: process.env.PUBLIC_URL + '/data/img/work/work_interactive-blind-controller.png',
                title: {
                    ENG: "Interactive Blind Controller",
                    KOR: "Interactive Blind Controller",
                },
                client: "HNINE",
                tags: ["App", "Introduction Movie", "Award"],
                categorys: ["app", "movie", "award"],
                featured: "large",
                award: "iF Gold"
            },
            {
                url: {
                    ENG: "https://www.hnine.com/en/project/arApp-renewal.html",
                    KOR: "https://www.hnine.com/project/arApp-renewal.html",
                },
                imgURL: process.env.PUBLIC_URL + '/data/img/work/work_ar-app-renewal.png',
                title: {
                    ENG: "AR App",
                    KOR: "AR App"
                },
                client: "IN-HOUSE PROJECT",
                tags: ["XR", "R&D", "3D"],
                categorys: ["xr", "rnd", "3d"],
                featured: "normal",
                award: ""
            },
            {
                url: {
                    ENG: "https://www.hnine.com/en/project/vr-home-renewal.html",
                    KOR: "https://www.hnine.com/project/vr-home-renewal.html",
                },
                imgURL: process.env.PUBLIC_URL + '/data/img/work/work_vr-home-renewal.png',
                title: {
                    ENG: "VR Home 3D Production",
                    KOR: "VR Home 3D 제작"
                },
                client: "SAMSUNG ELECTRONICS",
                tags: ["XR", "3D"],
                categorys: ["xr", "3d"],
                featured: "normal",
                award: ""
            },
            {
                url: {
                    ENG: "https://www.hnine.com/en/project/samsung-retail-robot-renewal.html",
                    KOR: "https://www.hnine.com/project/samsung-retail-robot-renewal.html",
                },
                imgURL: process.env.PUBLIC_URL + '/data/img/work/work_samsung-retail-robot-renewal.png',
                title: {
                    ENG: "Samsung Retail Robot Prototype",
                    KOR: "Samsung Retail Robot Prototype"
                },
                client: "SAMSUNG ELECTRONICS",
                tags: ["Hi-Fi Prototype", "Exhibition"],
                categorys: ["hifi", "exhibition"],
                featured: "normal",
                award: ""
            },
            {
                url: {
                    ENG: "https://www.hnine.com/en/project/ux-studio-renewal.html",
                    KOR: "https://www.hnine.com/project/ux-studio-renewal.html",
                },
                imgURL: process.env.PUBLIC_URL + '/data/img/work/work_ux-studio-renewal.png',
                title: {
                    ENG: "UX Studio",
                    KOR: "UX Studio"
                },
                client: "SK TELECOM",
                tags: ["VI"],
                categorys: ["visual"],
                featured: "normal",
                award: ""
            },
            {
                url: {
                    ENG: "https://www.hnine.com/en/project/mossland-renewal.html",
                    KOR: "https://www.hnine.com/project/mossland-renewal.html",
                },
                imgURL: process.env.PUBLIC_URL + '/data/img/work/work_the-hunters-app.png',
                title: {
                    ENG: "Mossland : The Hunters App",
                    KOR: "Mossland : The Hunters App"
                },
                client: "THE HUNTERS",
                tags: ["Introduction Movie"],
                categorys: ["movie"],
                featured: "normal",
                award: ""
            },
            {
                url: {
                    ENG: "https://www.hnine.com/en/project/ar-zone-renewal.html",
                    KOR: "https://www.hnine.com/project/ar-zone-renewal.html",
                },
                imgURL: process.env.PUBLIC_URL + '/data/img/work/work_ar-zone.png',
                title: {
                    ENG: "AR Zone",
                    KOR: "AR Zone"
                },
                client: "SAMSUNG ELECTRONICS",
                tags: ["XR", "3D", "Motion"],
                categorys: ["xr", "3d", "motion"],
                featured: "normal",
                award: ""
            },
            {
                url: {
                    ENG: "https://www.hnine.com/en/project/ar-emoji-sticker-renewal.html",
                    KOR: "https://www.hnine.com/project/ar-emoji-sticker-renewal.html",
                },
                imgURL: process.env.PUBLIC_URL + '/data/img/work/work_ar-emoji-sticker.png',
                title: {
                    ENG: "AR Emoji Sticker",
                    KOR: "AR Emoji Sticker",
                },
                client: "SAMSUNG",
                tags: ["Motion"],
                categorys: ["motion"],
                featured: "normal",
                award: ""
            },
            {
                url: {
                    ENG: "https://www.hnine.com/en/project/daelim-wall-pad-renewal.html",
                    KOR: "https://www.hnine.com//project/daelim-wall-pad-renewal.html",
                },
                imgURL: process.env.PUBLIC_URL + '/data/img/work/work_smart-home-wall-pad.png',
                title: {
                    ENG: "Smart Home Wall Pad & Mobile App",
                    KOR: "Smart Home Wall Pad & Mobile App",
                },
                client: "DAELIM",
                tags: ["VI"],
                categorys: ["visual"],
                featured: "normal",
                award: ""
            },
            {
                url: {
                    ENG: "https://www.hnine.com/en/project/ar-service-app-renewal.html",
                    KOR: "https://www.hnine.com/project/ar-service-app-renewal.html",
                },
                imgURL: process.env.PUBLIC_URL + '/data/img/work/work_ar-service-app.png',
                title: {
                    ENG: "AR Service App : Air Purifier, Location Based Service",
                    KOR: "AR Service App : Air Purifier, Location Based Service",
                },
                client: "SAMSUNG",
                tags: ["XR", "R&D"],
                categorys: ["xr", "rnd"],
                featured: "normal",
                award: ""
            },
            {
                url: {
                    ENG: "https://www.hnine.com/en/project/samsung-avatar-outfit-3d-renewal.html",
                    KOR: "https://www.hnine.com/project/samsung-avatar-outfit-3d-renewal.html",
                },
                imgURL: process.env.PUBLIC_URL + '/data/img/work/work_avatar-outfit.png',
                title: {
                    ENG: "Developing 3D Avatar Outfit",
                    KOR: "Avatar Outfit 3D 의상 제작",
                },
                client: "SAMSUNG ELECTRONICS",
                tags: ["XR", "3D"],
                categorys: ["xr", "3d"],
                featured: "normal",
                award: ""
            },
            {
                url: {
                    ENG: "https://www.hnine.com/en/project/owao-renewal.html",
                    KOR: "https://www.hnine.com/project/owao-renewal.html",
                },
                imgURL: process.env.PUBLIC_URL + '/data/img/work/work_owao.png',
                title: {
                    ENG: "OwaO",
                    KOR: "OwaO"
                },
                client: "IN-HOUSE",
                tags: ["XR", "R&D", "App", "3D"],
                categorys: ["xr", "rnd", "app", "3d"],
                featured: "small",
                award: ""
            },
            {
                url: {
                    ENG: "https://www.hnine.com/en/project/my-style-lab-renewal.html",
                    KOR: "https://www.hnine.com/project/my-style-lab-renewal.html",
                },
                imgURL: process.env.PUBLIC_URL + '/data/img/work/work_my-style-lab.png',
                title: {
                    ENG: "My Style Lab",
                    KOR: "My Style Lab",
                },
                client: "SEOUL",
                tags: ["XR", "Media Art"],
                categorys: ["xr", "media"],
                featured: "normal",
                award: ""
            },
            {
                url: {
                    ENG: "https://www.hnine.com/en/project/media-art-for-fuorisalone-renewal.html",
                    KOR: "https://www.hnine.com/project/media-art-for-fuorisalone-renewal.html"
                },
                imgURL: process.env.PUBLIC_URL + '/data/img/work/work_interactive-media-art-for-fuorisalone.png',
                title: {
                    ENG: "Interactive Media Art For Fuorisalone",
                    KOR: "Interactive Media Art For Fuorisalone",
                },
                client: "SAMSUNG ELECTRONICS",
                tags: ["Media Art"],
                categorys: ["media"],
                featured: "normal",
                award: ""
            },
            {
                url: {
                    ENG: "https://www.hnine.com/en/project/samsung-watch-face-studio-renewal.html",
                    KOR: "https://www.hnine.com/project/samsung-watch-face-studio-renewal.html",
                },
                imgURL: process.env.PUBLIC_URL + '/data/img/work/work_watch-face-studio.png',
                title: {
                    ENG: "Watch Face Studio",
                    KOR: "Watch Face Studio",
                },
                client: "SAMSUNG",
                tags: ["Introduction Movie"],
                categorys: ["movie"],
                featured: "normal",
                award: ""
            },
            {
                url: {
                    ENG: "https://www.hnine.com/en/project/statue-road-ar/index.html",
                    KOR: "https://www.hnine.com/project/statue-road-ar/index.html",
                },
                imgURL: process.env.PUBLIC_URL + '/data/img/work/work_statue-road-hero_pc.png',
                title: {
                    ENG: "Cheongju National Museum 'Statue Road AR'",
                    KOR: "국립 청주 박물관 ‘석신로드 AR’",
                },
                client: "Cheongju National Museum",
                tags: ["XR", "Exhibition", "Award"],
                categorys: ["xr", "exhibition", "award"],
                featured: "normal",
                award: "RedDot"
            },
        ],
    }
];

export default workData;